import React from 'react';

import Banner from './Banner';
import Form from './Form';
import Location from './Location';

const ContactUs:React.FC = () => (
  <>
    <Banner />
    <Form />
    <Location />
  </>
  );

export default ContactUs;
